import React, { useEffect, useState } from "react";
import Pending from "./Pending";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/BorderColor";
import CloseIcon from "@mui/icons-material/Close";
import EditLeaveApplication from "./EditLeaveApplication";
import { hoverScale } from "../../../components/DesignStandardize";
import { toast } from "react-toastify";

const UserPendingInfo = ({ id, isAdmin }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [pendingApplications, setPendingApplications] = useState([]);
  console.log("pending",pendingApplications);
  const [selectedLeaveID, setSelectedLeaveID] = useState(null);
  const [selectedLeaveName, setSelectedLeaveName] = useState("");
  const [selectedLeaveDate, setSelectedLeaveDate] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const toggleEditModal = (id) => {
    setShowEditModal((prevShowEditModal) => !prevShowEditModal);
  };

  const getPendingApplication = async () => {
    try {
      const response = await axios.get(`${apiUrl}/leave/detailsEmpID/${id}/0`);
      console.log("pending",response.data.leaves); 
      // Sort by DateApplied in descending order (latest first)
      const sortedLeaves = response.data.leaves.sort((a, b) => 
        new Date(b.DateApplied) - new Date(a.DateApplied)
      );
      setPendingApplications(sortedLeaves);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getPendingApplication();
  }, [id]);

  const handDeleteApplications = async (LeaveID, AppliedDate) => {
    if (
      window.confirm(
        `Are u sure u want to delete the application for ${AppliedDate}?`
      )
    ) {
      const response = await axios.delete(`${apiUrl}/leave/delete/${LeaveID}`);
      toast.success("Leave Application Deleted");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  return (
    <>
      <div className="bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-[0_8px_30px_rgb(0,0,0,0.12)] backdrop-blur-sm mt-6">
        <div className="p-6 sm:p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold text-[#2D2D2D]">Pending Applications</h2>
            <span className="text-sm text-amber-600 bg-amber-50 px-3 py-1 rounded-full font-medium">
              {pendingApplications?.length || 0} {pendingApplications?.length === 1 ? 'Application' : 'Applications'}
            </span>
          </div>
          
          {!pendingApplications || pendingApplications.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              <FontAwesomeIcon icon={faEllipsis} className="text-5xl text-gray-400 mb-4" />
              <p className="text-lg">No pending applications</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                  <tr>
                    <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      <FontAwesomeIcon icon={faUser} className="mr-2" />
                      Employee Name
                    </th>
                    <th scope="col" className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      <FontAwesomeIcon icon={faCalendarDays} className="mr-2" />
                      Applied Date
                    </th>
                    <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      Status
                    </th>
                    <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                      <FontAwesomeIcon icon={faEye} className="mr-2" />
                      Actions
                    </th>
                    {isAdmin === 0 && (
                      <>
                        <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Edit
                        </th>
                        <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                          Delete
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {pendingApplications?.map((item, index) => (
                    <tr
                      className="hover:bg-amber-50 transition duration-150"
                      key={index}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="text-sm font-medium text-gray-900">{item.Name}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="text-sm text-gray-700">{item.DateApplied}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        {(() => {
                          switch (item.Status) {
                            case 0:
                              return (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                                  <FontAwesomeIcon icon={faEllipsis} fade className="mr-1" />
                                  Pending
                                </span>
                              );
                            case 1:
                              return (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  <FontAwesomeIcon icon={faCheck} className="mr-1" />
                                  Approved
                                </span>
                              );
                            case 2:
                              return (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                  <FontAwesomeIcon icon={faExclamation} className="mr-1" />
                                  Disapproved
                                </span>
                              );
                            default:
                              return "Unknown Status";
                          }
                        })()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <button
                          onClick={() => {
                            setSelectedLeaveID(item.Leave_ID);
                            setSelectedLeaveName(item.Name);
                            setSelectedLeaveDate(item.DateApplied);
                          }}
                          className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-700 text-sm font-medium rounded-md hover:bg-blue-200 transition"
                        >
                          <FontAwesomeIcon icon={faEye} className="mr-2" />
                          View Application
                        </button>
                      </td>
                      {isAdmin === 0 && (
                        <>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <button
                              className={`inline-flex items-center px-3 py-2 bg-indigo-100 text-indigo-700 text-sm font-medium rounded-md hover:bg-indigo-200 transition ${hoverScale}`}
                              onClick={() => {
                                setSelectedLeaveID(item.Leave_ID);
                                toggleEditModal();
                              }}
                            >
                              <EditIcon fontSize="small" className="mr-1" />
                              Edit
                            </button>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-center">
                            <button
                              className={`inline-flex items-center px-3 py-2 bg-red-100 text-red-700 text-sm font-medium rounded-md hover:bg-red-200 transition ${hoverScale}`}
                              onClick={() =>
                                handDeleteApplications(
                                  item.Leave_ID,
                                  item.DateApplied
                                )
                              }
                            >
                              <DeleteIcon fontSize="small" className="mr-1" />
                              Delete
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {selectedLeaveID && (
        <Pending
          id={selectedLeaveID}
          name={selectedLeaveName}
          date={selectedLeaveDate}
        />
      )}

      {showEditModal && (
        <div className="z-10 fixed inset-0 flex items-center justify-center">
          <div
            className="bg-black bg-opacity-50 fixed inset-0"
            onClick={toggleEditModal}
          />
          <div className="card bg-white z-20 p-4 modal-white flex flex-col gap-3">
            <div className="card-title flex justify-between">
              <h2 className="text-center text-transparent bg-clip-text bg-gradient-to-b from-[#6782e6] to-[#214DED] md:font-extrabold m-0">
                Edit Leave Application
              </h2>
              <CloseIcon
                onClick={toggleEditModal}
                fontSize="1px"
                className={`hover:cursor-pointer hover:bg-[#414141] w-5 h-5 hover:text-white rounded-full p-[1px] ${hoverScale}`}
              />
            </div>
            <EditLeaveApplication id={selectedLeaveID} />
          </div>
        </div>
      )}
    </>
  );
};

export default UserPendingInfo;
